export const ChartErrorState = ({ error }: { error: unknown }) => (
  <pre className="max-h-80 overflow-auto rounded-md bg-muted p-4 text-xs text-destructive">
    {String(error)}
  </pre>
)
